import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { ArrowLeft, Save, Sparkles } from "lucide-react";
import { ApiService } from "../../services/api";
import { useModal } from "../../hooks/useModal";

export default function IlmekContentPackNewPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showAlert } = useModal();

  const isGenerateMode = searchParams.get("mode") === "generate";

  const [kazanimKodu, setKazanimKodu] = useState("");
  const [ders, setDers] = useState("");
  const [sinif, setSinif] = useState<string>("");
  const [unite, setUnite] = useState("");
  const [baslik, setBaslik] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!kazanimKodu.trim()) {
      await showAlert({ title: "Eksik bilgi", message: "Kazanım kodu zorunludur.", type: "warning" });
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        kazanimKodu: kazanimKodu.trim(),
        ders: ders.trim() || undefined,
        sinif: sinif ? Number(sinif) : undefined,
        unite: unite.trim() || undefined,
        baslik: baslik.trim() || undefined,
      };
      const pack = isGenerateMode
        ? await ApiService.generateIlmekContentPack(payload)
        : await ApiService.createIlmekContentPack(payload);
      navigate(`/ilmek/edit/${pack.id}`);
    } catch (error: any) {
      await showAlert({
        title: "Hata",
        message: error?.message || "Paket oluşturulamadı.",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-200";

  return (
    <div className="p-4 sm:p-6 max-w-2xl mx-auto">
      <Link
        to="/ilmek"
        className="inline-flex items-center gap-1.5 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white mb-4"
      >
        <ArrowLeft className="w-4 h-4" /> Paketler
      </Link>

      <div className="space-y-4 bg-white border border-gray-200 rounded-lg p-5">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">
            {isGenerateMode ? "AI ile İçerik Paketi Üret" : "Yeni İçerik Paketi"}
          </h1>
          <p className="text-sm text-gray-500">
            {isGenerateMode
              ? "Kazanım bağlamından kaynağa-sadık taslak paket üretilir (öğretmen onayından sonra yayınlanır)."
              : "Taslak paket oluştur; içeriği bir sonraki adımda doldurursun."}
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Kazanım Kodu *</label>
          <input
            type="text"
            value={kazanimKodu}
            onChange={(e) => setKazanimKodu(e.target.value)}
            placeholder="örn. FB.5.1.2.2"
            className={`${inputCls} font-mono`}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ders</label>
            <input type="text" value={ders} onChange={(e) => setDers(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Sınıf</label>
            <input
              type="number"
              value={sinif}
              onChange={(e) => setSinif(e.target.value)}
              placeholder="5-8 (ortaokul)"
              className={inputCls}
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Ünite</label>
          <input type="text" value={unite} onChange={(e) => setUnite(e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Başlık</label>
          <input type="text" value={baslik} onChange={(e) => setBaslik(e.target.value)} className={inputCls} />
        </div>

        <div className="flex justify-end pt-2">
          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-purple-600 text-white text-sm font-medium hover:bg-purple-700 disabled:opacity-50"
          >
            {isGenerateMode ? <Sparkles className="w-4 h-4" /> : <Save className="w-4 h-4" />}
            {submitting ? "İşleniyor..." : isGenerateMode ? "Üret" : "Oluştur"}
          </button>
        </div>
      </div>
    </div>
  );
}
